<template>
  <v-container>
    <v-row justify="center" v-if="stores.length <= 10">
      <v-col v-for="(store, i) in stores" v-bind:key="store.id" cols="12" xs="12" md="4">
        <v-card @click="setStore(store, i)" :loading="loader && i == index">
          <v-card-title>
            <span style="color: #FF5733">{{ store.Name }}</span>
          </v-card-title>

          <v-card-text></v-card-text>
        </v-card>
      </v-col>

      <!-- cargos -->
      <v-col v-show="role == 3" v-for="(store, i) in cargo" v-bind:key="store.id" cols="12" xs="12" md="4">
        <v-card @click="setStore(store, i)" :loading="loader && i == index">
          <v-card-title>
            <span style="color: #ff4081">{{ store.Name }}</span>
          </v-card-title>

          <v-card-text></v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-else class="text" justify="center">
      <v-col cols="12" md="7">
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
      </v-col>

      <v-col cols="12" md="7">
        <v-data-table :items-per-page="70" :mobile-breakpoint="0" :headers="headers" :items="stores" :search="search">
          <!-- action template -->
          <template v-slot:body="{ items }">
    <tbody>
      <tr v-for="item in items" :key="item.id" @click="navigateToStore(item)" style="cursor: pointer;">
        <td><span style="color: blue; font-weight: bold;">{{ item.Name }}</span></td>
      </tr>
    </tbody>
  </template>
          <!-- end -->
        </v-data-table>
      </v-col>
    </v-row>



    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>

export default {
  components: {

  },
  computed: {
    role() {
      return localStorage.getItem("userRole");
    },
    activeStore() {
      return localStorage.getItem("store_id");
    },
  },
  data() {
    return {
      IsDistributor: "",
      loader: false,
      shopDialog: false,
      eWalletBalance: null,
      Smsbalance: null,
      CardCode: null,
      quickItem: {},
      cargo: [],
      index: null,
      stores: [],
      search: "",
      headers: [
        { text: "Name", value: "Name" },
      ],
    };
  },
  methods: {
    openCreate() {
      this.shopDialog = true;
    },
    saveShop(data) {
      const url = "/stores";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            self.stores = [...self.stores, res.ResponseData];
            self.shopDialog = false;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    setStore(store, i) {
      this.index = i;
      localStorage.removeItem("storeName");
      localStorage.removeItem("store_id");
      localStorage.setItem("storeName", store.Name);
      localStorage.setItem("store_id", store.id);
      this.loader = true;
      this.$router.push("/subscriber/dashboard");
    },
    navigateToStore(store) {
      localStorage.removeItem("storeName");
      localStorage.removeItem("store_id");
      localStorage.setItem("storeName", store.Name);
      localStorage.setItem("store_id", store.id);
      this.loader = true;
      this.$router.push("/subscriber/dashboard");
    },
    getUserDetails() {
      var userId = localStorage.getItem("userId");
      const self = this;
      this.$store
        .dispatch("get", `/user-stores/${userId}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    Promise.all([this.getUserDetails()]);
  },
};
</script>

<style lang="scss" scoped></style>